export default __webpack_public_path__ + "static/media/textopagos.859f248d.png";